<template>
  <div>
    <AvailablePlan />
    <PaymentMethod v-if="paymentMethod == 'credit_card'" />
    <PaymentHistory v-if="paymentMethod == 'credit_card'" />
    <CompanyAddress />
  </div>
</template>

<script>
import CompanyAddress from '../components/PaymentSetting/CompanyAddress'
import AvailablePlan from '../components/PaymentSetting/AvailablePlan'
import PaymentHistory from '../components/PaymentSetting/PaymentHistory'
import PaymentMethod from '../components/PaymentSetting/PaymentMethod'

export default {
  name: 'PaymentSetting',
  components: {PaymentMethod, AvailablePlan, CompanyAddress, PaymentHistory},
  computed: {
    paymentMethod() {
      const companyUuid = this.$route.params.company_uuid
      let payment_method = null
      gon.currentUser.invited_companies.forEach((item) => {
        if ( item.uuid === companyUuid ) payment_method = item.payment_method
      })

      return payment_method
    }
  },
}
</script>
